export default __webpack_public_path__ + "static/media/mainz_m.2e34e022.jpg";